import React, { useState, useEffect, useRef, useContext } from "react";
import { NavLink } from "react-router-dom";
import "./ScrollableSideBar.css";
import styled from "styled-components";

import Settings from "../assets/icons/settings.svg";
import Draft from "../assets/icons/draft.svg";


const Sidebar = () => {
  const menuItems = [
    { path: "/services", key: "services", icon: Draft, label: "Ordem de Serviço", id: 4 },
    { path: "/configuration", key: "configuration", icon: Settings, label: "Serviços", id: 9 },
  ];

  const [click, setClick] = useState(false);

  function getWidthImg(widthImg) {
    return widthImg ? widthImg : '30px'
  }

  const handleClick = () => setClick(!click);
  const validateSelected = (iconName) => window.location.pathname === iconName;

  return (
    <SidebarContainer>
      <Validate>
        <Button clicked={click} onClick={handleClick} style={{ cursor: 'pointer' }} />
      </Validate>
      <SlickBar clicked={click} className="scrollable-content-side-bar">
        {menuItems.map(({ path, key, icon, label, id, widthImg }) => {
          return (
            <Item key={id} itemSelected={validateSelected(path)} activeClassName="active" to={path}>
              <img
                src={icon}
                style={{ maxHeight: '30px', maxWidth: '30px', width: getWidthImg(widthImg), margin: "0px" }}
                alt={label}
              />
              <IconName clicked={click}>
                <Text clicked={click}>{label}</Text>
              </IconName>
            </Item>
          );
        })}
      </SlickBar>
    </SidebarContainer>
  );
};

const SkeletonItem = styled.div`
  width: 100%;
  height: 30px;
  background: rgba(255, 255, 255, 0.2);
  margin: 10px 0;
  border-radius: 5px;
  animation: pulse 1.5s infinite ease-in-out;

  @keyframes pulse {
    0% { opacity: 0.6; }
    50% { opacity: 1; }
    100% { opacity: 0.6; }
  }
`;

const SidebarContainer = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
`;

const Validate = styled.div`
  display: flex;
  align-items: center;
  width: 100%;
  height: max-content;
  padding: 16px 5px;
  margin-left: 5px;
`;

const Button = styled.button`
  background-color: transparent;
  width: 3em;
  border: none;
  height: 100%;
  display: flex;
  justify-content: center;
  position: relative;
  cursor: pointer;

  &::before,
  &::after {
    content: "";
    background-color: white;
    height: 5px;
    width: 1rem;
    position: absolute;
    transition: transform 0.3s ease;
  }

  &::before {
    transform: ${({ clicked }) => (clicked ? "rotate(135deg)" : "rotate(0)")};
  }
  &::after {
    transform: ${({ clicked }) => (clicked ? "rotate(-135deg)" : "rotate(0)")};
  }
`;

const SlickBar = styled.ul`
  display: flex;
  flex-direction: column;
  align-items: center;
  background: transparent;
  padding: 0;
  width: ${({ clicked }) => (clicked ? "12rem" : "4rem")};
  transition: width 0.5s ease-in-out;
  overflow-y: auto;
`;

const Item = styled(NavLink)`
  text-decoration: none;
  color: white;
  width: 100%;
  cursor: pointer;
  margin: 1rem 0;
  display: flex;
  align-items: center;
  padding: 5px 15px;
  min-height: 30px;
  max-height: 30px;
  transition: background 0.3s ease-in-out;

  &:hover {
    border-right: 5px solid white;
    img {
      filter: invert(100%) sepia(0%) saturate(0%) hue-rotate(93deg) brightness(103%) contrast(103%);
    }
  }

  img {
    width: 1.6rem;
    height: auto;
    transition: filter 0.25s ease-in-out;
    filter: ${({ itemSelected }) =>
    itemSelected
      ? "invert(100%) sepia(0%) saturate(100%) hue-rotate(200deg) brightness(120%) contrast(100%)"
      : "invert(70%) sepia(20%) saturate(500%) hue-rotate(200deg) brightness(80%) contrast(90%)"};
  }
`;

const IconName = styled.div`
  margin-left: 1.5rem;
  align-items: center;
  min-width: 100px;
  display: ${({ clicked }) => (clicked ? "flex" : "none")};
`;

const Text = styled.span`
  overflow: hidden;
  transition: color 0.3s ease-in-out;
  color: ${({ clicked }) => (clicked ? 'white' : 'transparent')};
  display: flex;
  white-space: normal;
`;

export default Sidebar;
